import {PRESCRIPTION_STATUS} from 'constants/success';
import {OrderDetailsItemsType} from 'types/orderDetailsTypes';
import {FieldType, ItemsType} from 'types/successPage';

/**
 * generate array with id of item TYP with new status prescription
 */
export const getStatusesUpdatedItems = (items: Array<FieldType>) => {
    const itemsArr: ItemsType = items.map(item => {
        let prescriptionStatus: string;
        switch (true) {
            case Boolean(item?.doctorDetails?.name):
                prescriptionStatus = PRESCRIPTION_STATUS.FILL_SUCCESS;
                break;
            case Boolean(item?.fileSrc):
                prescriptionStatus = PRESCRIPTION_STATUS.UPLOAD_SUCCESS;
                break;
            case item?.isEyeExam:
                prescriptionStatus = PRESCRIPTION_STATUS.EYE_EXAM;
                break;
            case item?.isVisiblyExam:
                prescriptionStatus = PRESCRIPTION_STATUS.VISIBLY;
                break;
            default:
                prescriptionStatus = PRESCRIPTION_STATUS.DEFAULT;
                break;
        }
        return {
            orderItemId: item.orderItemId,
            prescriptionStatus,
        };
    });
    return itemsArr;
};
/**
 * get prescription status of item product after update order (TYP CL)
 */
export const getPrescriptionStatusAfterUpdateOrder = (
    items: ItemsType,
    item: OrderDetailsItemsType,
) => {
    return (
        items?.find(orderItem => orderItem.orderItemId === String(item.id))?.prescriptionStatus ||
        ''
    );
};
